"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDcf = parseDcf;
exports.parseDcfSectionMap = parseDcfSectionMap;
const fflate_1 = require("fflate");
const GATE_XML_PATH = 'objects/Gate.xml';
const PIN_XML_PATH = 'objects/Pin.xml';
const NET_XML_PATH = 'objects/Net.xml';
const XCON_ID_RE = /\\(I\d+)\\/;
const XCON_NET_ID_RE = /\\(N\d+)\\/;
const PIN_A_ATTR_RE = /^[^.]+\.(.+)$/;
function parseDcf(dcfBytes) {
    const sectionMap = new Map();
    const instancePinMap = new Map();
    const instanceAttributes = new Map();
    const netAttributesByPhysName = new Map();
    const physNetNameByXconId = new Map();
    let unzipped;
    try {
        unzipped = (0, fflate_1.unzipSync)(dcfBytes);
    }
    catch {
        return { sectionMap, instancePinMap, instanceAttributes, netAttributesByPhysName, physNetNameByXconId };
    }
    const gateEntry = unzipped[GATE_XML_PATH];
    if (gateEntry !== undefined) {
        collectGateEntries(new TextDecoder('utf-8').decode(gateEntry), sectionMap, instanceAttributes);
    }
    const pinEntry = unzipped[PIN_XML_PATH];
    if (pinEntry !== undefined) {
        collectPinEntries(new TextDecoder('utf-8').decode(pinEntry), instancePinMap);
    }
    const netEntry = unzipped[NET_XML_PATH];
    if (netEntry !== undefined) {
        collectNetEntries(new TextDecoder('utf-8').decode(netEntry), netAttributesByPhysName, physNetNameByXconId);
    }
    return { sectionMap, instancePinMap, instanceAttributes, netAttributesByPhysName, physNetNameByXconId };
}
function parseDcfSectionMap(dcfBytes) {
    return parseDcf(dcfBytes).sectionMap;
}
const ATTR_RE = /<a\s+N="([^"]+)"[^>]*>\s*<v\s+V="([^"]*)"/g;
function collectGateEntries(xml, secOut, attrsOut) {
    const oTagRe = /<o\s[^>]*N="([^"]+)"[^>]*>/g;
    let oMatch;
    while ((oMatch = oTagRe.exec(xml)) !== null) {
        const nAttr = oMatch[1];
        const idMatch = XCON_ID_RE.exec(nAttr);
        if (idMatch === null) {
            continue;
        }
        const xconId = idMatch[1];
        const searchFrom = oMatch.index + oMatch[0].length;
        const searchTo = Math.min(searchFrom + 4096, xml.length);
        const window = xml.slice(searchFrom, searchTo);
        const nextO = window.indexOf('<o ');
        const searchWindow = nextO >= 0 ? window.slice(0, nextO) : window;
        const attrs = {};
        ATTR_RE.lastIndex = 0;
        let attrMatch;
        while ((attrMatch = ATTR_RE.exec(searchWindow)) !== null) {
            attrs[attrMatch[1]] = attrMatch[2];
        }
        if (Object.keys(attrs).length > 0) {
            attrsOut.set(xconId, attrs);
        }
        const secStr = attrs['SEC'];
        if (secStr !== undefined) {
            const sec = parseInt(secStr, 10);
            if (!isNaN(sec)) {
                secOut.set(xconId, sec);
            }
        }
    }
}
function collectPinEntries(xml, out) {
    const oTagRe = /<o\s[^>]*N="([^"]+)"[^>]*A="([^"]+)"[^>]*>/g;
    let oMatch;
    while ((oMatch = oTagRe.exec(xml)) !== null) {
        const nAttr = oMatch[1];
        const aAttr = oMatch[2];
        const idMatch = XCON_ID_RE.exec(nAttr);
        if (idMatch === null) {
            continue;
        }
        const xconId = idMatch[1];
        const pinNameMatch = PIN_A_ATTR_RE.exec(aAttr);
        if (pinNameMatch === null) {
            continue;
        }
        const pinName = pinNameMatch[1];
        const searchFrom = oMatch.index + oMatch[0].length;
        const searchTo = Math.min(searchFrom + 512, xml.length);
        const window = xml.slice(searchFrom, searchTo);
        const pnMatch = /<a\s+N="PN"[^>]*>\s*<v\s+V="([^"]+)"/.exec(window);
        if (pnMatch === null) {
            continue;
        }
        const pn = pnMatch[1].trim();
        if (pn.length === 0) {
            continue;
        }
        let pinsByName = out.get(xconId);
        if (pinsByName === undefined) {
            pinsByName = new Map();
            out.set(xconId, pinsByName);
        }
        pinsByName.set(pinName, pn);
    }
}
function collectNetEntries(xml, out, physNetNameOut) {
    const oTagRe = /<o\s[^>]*N="([^"]+)"[^>]*>/g;
    let oMatch;
    while ((oMatch = oTagRe.exec(xml)) !== null) {
        const nAttr = oMatch[1];
        const idMatch = XCON_NET_ID_RE.exec(nAttr);
        if (idMatch === null) {
            continue;
        }
        const xconId = idMatch[1];
        const searchFrom = oMatch.index + oMatch[0].length;
        const searchTo = Math.min(searchFrom + 2048, xml.length);
        const window = xml.slice(searchFrom, searchTo);
        const nextO = window.indexOf('<o ');
        const searchWindow = nextO >= 0 ? window.slice(0, nextO) : window;
        const attrs = {};
        ATTR_RE.lastIndex = 0;
        let attrMatch;
        while ((attrMatch = ATTR_RE.exec(searchWindow)) !== null) {
            attrs[attrMatch[1]] = attrMatch[2];
        }
        const physNetName = attrs['PHYS_NET_NAME'];
        if (physNetName === undefined || physNetName.length === 0) {
            continue;
        }
        physNetNameOut.set(xconId, physNetName);
        const { PHYS_NET_NAME: _, ...rest } = attrs;
        if (Object.keys(rest).length > 0) {
            out.set(physNetName, rest);
        }
    }
}
//# sourceMappingURL=dcfParser.js.map